/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Deck_Upload_Attr_SelfInputs */



/**
* | output |
* | --- |
* | "Your deck" |
*
* @param {Deck_Upload_Attr_SelfInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const deck_upload_attr_self = /** @type {((inputs?: Deck_Upload_Attr_SelfInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deck_Upload_Attr_SelfInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo deck")
	return /** @type {LocalizedString} */ ("Your deck")
});